import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from '../routing/app-routing.module';
import { ApiCallsService, CmpAuthService, CmpSharedModule } from 'icamppro-shared-components';
import { AppLoadService } from '../services/app-load.service';
import { SharedUiComponentsModule } from '../modules/shared-ui-components/shared-ui-components.module';
import { CmpAppSettings } from 'src/services/cmp-app-settings.service';
import { DatePipe } from '@angular/common';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import player from "lottie-web";
import { SentryErrorHandler } from 'src/services/sentry-error-handler';
import { ApiRoutePathInterceptor, FEATURE_FLAGS_API_URL_STRING, FeatureFlagService, CmpSharedComponentsModule } from '@icamppro-customer-portal/shared/cmp-base';
import { AppRoutes } from 'src/routing/routes';
import { CMP_ENV_SETUP } from './cmp-env-setup.injection-token';

function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CmpSharedModule.forRoot(AppLoadService.initEnvSetupObject),
    SharedUiComponentsModule,
    LottieComponent,
    CmpSharedComponentsModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideLottieOptions({ player: playerFactory }),
    AppLoadService,
    CmpAppSettings,
    ApiCallsService, // needed to add the http interceptor below
    CmpAuthService, // needed to add the http interceptor below
    FeatureFlagService,
    {
        provide: FEATURE_FLAGS_API_URL_STRING,
        useValue: AppRoutes.backendApiUrl.featureFlags,
    },
    provideAppInitializer(() => inject(AppLoadService).initAppSettingsAsync(true)),
    {
      provide: CMP_ENV_SETUP,
      useFactory: AppLoadService.initEnvSetupObject
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiRoutePathInterceptor,
        multi: true
    },
    DatePipe,
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandler
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
